import styled from "styled-components";

interface HeroSecondaryProps {
  colorScheme?: string;
}

export const HeroSecondary = styled.div<HeroSecondaryProps>`
  min-height: calc( 100svh - ${({ theme }) => theme.rem(114)} );
  padding: ${({ theme }) => theme.rem(48, 0)};
  position: relative;
  overflow: hidden;
  align-content: flex-end;

  ${({ theme }) => theme.mediaQuery.md(`
    min-height: calc(70svh);
  `)};

  ${({ theme }) => theme.mediaQuery.lg(`
    padding: ${theme.rem(96, 0)};
    min-height: calc(85svh);
  `)};

  ${({ theme }) => theme.mediaQuery.xl(`
    min-height: calc( 100svh - ${theme.rem(114)} );
  `)};
`

export const HeroSecondaryImageWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;

  img {
    object-fit: cover;
    object-position: center;
  }
`

export const HeroSecondaryBackgroundVideo = styled.div`
  height: 100%;

  .plyr {
    height: 100%;
  }

  video {
    object-fit: cover;
  }
`